import geoData from "@/assets/data/usa-geo.json";
import { DAT_ONE_ZONE_REGEX } from "@/constants/regex";

export const getFullLocation = (location?: string) => {
  if (
    !location ||
    location.toLowerCase() === "anywhere" ||
    !!location.match(DAT_ONE_ZONE_REGEX)
  ) {
    return "";
  }
  if (location.length < 3) {
    return (
      geoData.features.find((feature) => feature.properties.id === location)
        ?.properties.name || location
    );
  }

  return location;
};

export const getRequestDataV2 = (
  loadData: {
    origin?: string;
    destination?: string;
    truckLocation?: string;
  },
  isBroker: boolean
) => {
  let requestData: {
    originCity: string;
    destinationCity: string;
    viaCities?: string[];
  } = isBroker
    ? {
        originCity: getFullLocation(loadData.origin),
        viaCities: [getFullLocation(loadData.truckLocation)],
        destinationCity: getFullLocation(loadData.destination),
      }
    : {
        originCity: getFullLocation(loadData.truckLocation || loadData.origin),
        viaCities: loadData.truckLocation
          ? [getFullLocation(loadData.origin)]
          : [],
        destinationCity: getFullLocation(loadData.destination),
      };

  return requestData;
};
